import { render, staticRenderFns } from "./renthouse.vue?vue&type=template&id=0bb9a66a&"
import script from "./renthouse.vue?vue&type=script&lang=js&"
export * from "./renthouse.vue?vue&type=script&lang=js&"
import style0 from "./renthouse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports